import { render, staticRenderFns } from "./_error.vue?vue&type=template&id=4cc64e44&"
import script from "./_error.vue?vue&type=script&lang=js&"
export * from "./_error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports